module.exports = __webpack_public_path__ + "static/media/scheme10.87c77282.png";